<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {MessageStore} from "../../../../../store/MessageStore";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import FontAwesomeView from "../../../../../component/common/Image/FontAwesomeView.svelte";
    import {SpaceCompanyDepartmentTable} from "../../../../../lib/Table/SpaceCompanyDepartmentTable";
    import CreatedUpdatedView from "../../../../../component/common/Value/CreatedUpdatedView.svelte";

    const dispatcher = createEventDispatcher();


    export let space;
    export let spaceCompanyDepartment;

    onMount(() => {
    });

    function onClickEdit() {
        dispatcher('edit', {spaceCompanyDepartment: spaceCompanyDepartment});
    }

    function onClickDelete() {

        MessageStore.showConfirmInformationOKCancel("削除してもよいですか？", () => {
            const paramMap = {};
            paramMap['space_id'] = space.id;
            paramMap['id'] = spaceCompanyDepartment.id;
            const url = UrlUtil.createApiUrl("space_company_department");

            HttpRequestUtil.deleteRequest(url, paramMap, (response) => {

                console.log(response);
                const body = response['body'];

                dispatcher('update');

            });

        });
    }


</script>

<tr class="space-company-department-row-view">
    <td>
                            <span class="edit-button icon-button" on:click={onClickEdit}>
                                <FontAwesomeView icon="edit"/>
                            </span>
    </td>
    <td>{spaceCompanyDepartment.company_name}</td>
    <td>
        {#if spaceCompanyDepartment.department_name != null}
            {spaceCompanyDepartment.department_name}
        {:else}
            all
        {/if}
    </td>
    <td>{ SpaceCompanyDepartmentTable.AuthorityType.map[spaceCompanyDepartment.authority_type]}</td>
    <td>
        <CreatedUpdatedView model={spaceCompanyDepartment}/>
    </td>

    <td>
        <span class="trash-button icon-button" on:click={onClickDelete}>
            <FontAwesomeView icon="trash"/>
        </span>
    </td>
</tr>
<style lang="scss">
    .space-company-department-row-view {

    }
</style>